// extracted by mini-css-extract-plugin
export default {"base":"LinkButton_base__ZiA0d","danger":"LinkButton_danger__MgIBc","stickLeft":"LinkButton_stickLeft__oT0gS"};